import React, { useMemo } from 'react';

import { css } from '@emotion/react';
import { Skeleton } from '@mui/material';
// import ScrollContainer from 'react-indiana-drag-scroll';

import Table from '@components/Common/Table';

import { titleStyle } from '@styles/common';

import { TOTAL_PORTFOLIO_LIST_HEADER } from '@constants/tableheader';

/** 조합 관리 > 전체 포트폴리오사 목록 스켈레톤 */
const TotalPortfolioListSkeleton = () => {
  /** 테이블용 데이터 */
  const tableData = useMemo(
    () =>
      Array.from({ length: 10 })?.map((_: any, i: number) => ({
        id: i,
        no: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        portfolioName: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        groupName: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        totalInvestmentCount: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        lastInvestDate: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
        totalInvestmentAmount: (
          <div css={items}>
            <Skeleton variant="text" width={80} />
          </div>
        ),
      })),
    []
  );

  return (
    <>
      <div css={[titleStyle, tooltips]}>
        <Skeleton variant="text" width={210} />
      </div>

      {/* 검색어 입력 영역 */}
      <Skeleton
        variant="rectangular"
        width={426}
        height={54}
        sx={{ borderRadius: '5px', margin: '20px 0 30px' }}
      />

      {/* 테이블 영역 */}
      <div css={counts}>
        <Skeleton variant="text" width={40} />
      </div>
      {/* <ScrollContainer css={tableWrap} hideScrollbars={false}> */}
      <Table header={TOTAL_PORTFOLIO_LIST_HEADER} data={tableData} />
      {/* </ScrollContainer> */}
    </>
  );
};

export default TotalPortfolioListSkeleton;

const tooltips = css`
  margin-top: 60px;
  button {
    top: 0;
  }
`;

// const tableWrap = css`
//   border-radius: 5px 5px 0 0;
//   overflow-x: auto;
//   padding: 1px;
//   &::-webkit-scrollbar {
//     width: 4px;
//     height: 5px;
//   }
//   &::-webkit-scrollbar-thumb {
//     background: ${palette.gray4};
//     height: 30%;
//   }
//   &::-webkit-scrollbar-track {
//     background: ${palette.gray3};
//   }

//   table {
//     width: calc(1920px - 250px - 82px);
//   }
// `;

const counts = css`
  margin-bottom: 10px;
  font-size: 14px;
  strong {
    font-weight: 700;
  }
`;

const items = css`
  display: flex;
  justify-content: center;
`;
